module.exports = __webpack_public_path__ + "img/es_mi_videostill5.f23b7438.jpg";